<script lang="ts">
	import { fade } from 'svelte/transition';
	import Icon from '../basic/Icon.svelte';

	interface Props {
		type?: string;
		dismissible?: boolean;
		button?: any;
		children?: import('svelte').Snippet;
		onDismiss: () => void;
	}

	let { type = 'error', dismissible = true, button = null, children, onDismiss }: Props = $props();

	function openLink() {
		if (button.localNavigation) {
			window.open(button.link, '_self');
		} else {
			window.open(button.link, '_blank');
		}
	}
</script>

<div class="bg-white dark:bg-dark-300 rounded flex shadow-lg pointer-events-auto" transition:fade>
	<div class="fill-white {type} icon flex items-center rounded-l px-2">
		{#if type === 'success'}
			<Icon name="check" />
		{:else if type === 'error'}
			<Icon name="fire"  />
		{:else}
			<Icon name="exclamation"/>
		{/if}
	</div>

	<div class="font-bold flex mx-4 py-2">
		{@render children?.()}
	</div>

	{#if button}
		<button class="primary-button" onclick={openLink} type="button">
			{button.label}
		</button>
	{/if}

	{#if dismissible}
		<button class="close" onclick={() => onDismiss()} aria-label="info">
			<i class="fas fa-times-circle fa-lg"></i>
		</button>
	{/if}
</div>

<style>
	.container {
		min-height: 48px;
		min-width: 450px;
	}

	.icon {
		min-height: 32px;
	}

	.error {
		--tw-bg-opacity: 1;
		background-color: rgb(168 7 39 / var(--tw-bg-opacity, 1));
}

	.error:where(.dark, .dark *) {
		--tw-bg-opacity: 1;
		background-color: rgb(56 56 56 / var(--tw-bg-opacity, 1));
		fill: #a80727;
}
	.success {
		--tw-bg-opacity: 1;
		background-color: rgb(0 102 0 / var(--tw-bg-opacity, 1));
}
	.info {
		--tw-bg-opacity: 1;
		background-color: rgb(45 218 255 / var(--tw-bg-opacity, 1));
}
	.close {
		margin-left: 0px;
		margin-right: 0px;
		margin-bottom: auto;
		border-width: 0px;
		background-color: transparent;
		padding: 0px;
		--tw-text-opacity: 1;
		color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

	.primary-button {
		background-color: transparent;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		--tw-text-opacity: 1;
		color: rgb(23 137 192 / var(--tw-text-opacity, 1));
}

	.primary-button:hover {
		--tw-text-opacity: 1;
		color: rgb(45 218 255 / var(--tw-text-opacity, 1));
}

	.primary-button:where(.dark, .dark *) {
		--tw-text-opacity: 1;
		color: rgb(255 152 0 / var(--tw-text-opacity, 1));
}
</style>
